import React from "react";
import { Link } from "react-router-dom";

function Card({ item }) {
  console.log(item);  
  return (
    <div className="featured-card">
      {item?.image && (
        <img src={item?.image} alt={item?.name} className="featured-image" />
      )}

      <div className="featured-overlay">
        <h3 className="featured-title">{item.name}</h3>
        <Link
          to={`/categories/${item?.slugPath || item?.slug}`}
          className="featured-btn"
        >
          Discover
        </Link>
      </div>
    </div>

  
  );
}

export default Card;
